import FieldLabel from "@/components/company/shared/field-label";
import { type ReactNode } from "react";

type KeyValueRowProps = {
  label: string;
  children: ReactNode;
};

/**
 * Single-line label/value row used inside divided lists (web traffic, legal
 * info, funding metrics). Pair with a `divide-y` container to render a clean
 * tabular block.
 */
export default function KeyValueRow({ label, children }: KeyValueRowProps) {
  return (
    <div className="flex items-center justify-between gap-3 min-w-0 py-2">
      <FieldLabel className="shrink-0">{label}</FieldLabel>
      <span className="text-sm font-semibold break-words text-right min-w-0">
        {children}
      </span>
    </div>
  );
}
